import angular, { ILogService, ITimeoutService } from 'angular'
import { trim } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { ICambioEstadoDoc, IGestionEstado } from 'src/model/candidato-api'

class TarjetaEstadoComponentCtrl {
  st!: IGestionEstado

  dirty = false

  editando: boolean = false
  isnew: boolean = false

  model: ICambioEstadoDoc | null = null

  mails = {
    text: '',
  }

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[TarjetaEstadoComponentCtrl] onInit')

    this._initEstado(this.st)

    if (!this.st.st.idestado) {
      // sin pregunta?
      this.editarEstado()
    }
  }

  $postLink() {
    // this.$timeout(() => (this.$element.find('select') as any).formSelect(), 10)
  }

  private _initEstado(_st: IGestionEstado) {
    this.isnew = !_st.st.idestado

    this.model = {
      st: angular.copy(_st.st),
      mails: [],
    }

    this.mails.text = _st.mails?.map((m) => m.mail).join('\n') || ''

    this.dirty = false
  }

  guardarEstado() {
    // separar los mails por líneas
    console.log('mails--> ', this.mails.text)

    // actualizar los mails
    this.model.mails = this._separaMails(this.mails.text)

    if (this.isnew)
      return this.AccesoDatos.Datos_Client.nuevoEstadoDoc(this.model) //
        .then((response) => this._initEstado((this.st = response)))
    else
      this.AccesoDatos.Datos_Client.cambioEstadoDoc(this.st.st.idestado, this.model) //
        .then((response) => this._initEstado((this.st = response)))
  }

  private _separaMails(text: string) {
    return text.split('\n').map((s) => trim(s))
  }

  editarEstado() {
    this.editando = !this.editando

    if (this.editando) this.$timeout(() => M.updateTextFields(), 1)

    this.$timeout(() => {
      this.$timeout(() => (this.$element.find('select') as any).formSelect(), 1)

      let textarea = this.$element.find('.materialize-textarea')

      if (textarea && textarea[0]) M.textareaAutoResize(textarea)

      if (this.isnew) {
        let textidentifier = this.$element.find('.st_identifier')

        if (textidentifier && textidentifier[0]) {
          textidentifier[0].focus()
        }
      }
    }, 200)
  }

  revertEstado() {
    this._initEstado(this.st)
  }
}

angular.module('candidato').component('tarjetaEstado', {
  bindings: {
    st: '<',
  },
  controller: TarjetaEstadoComponentCtrl,
  template: require('./tarjeta-estado.component.html'),
  // templateUrl: "tarjeta-estado.component.html",
})
